<template>
   <div>
      <a href="https://wa.me/5551983599666" target="_blank" title="Fale com a gente pelo WhatsApp">
         <v-icon  :class="isDashboard ? 'text-white' : 'text-primary'" style="margin-top: -6px" :scale="scale" name="brands/whatsapp"></v-icon>
      </a>
   </div>
</template>

<script>
export default {
   name: 'BtnWhatssApp',
   props: {
      scale: {
         type: String,
         default: "1.4"
      },
      isDashboard: {
         type: Boolean,
         default: false
      }
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
